<div class="wrapper mb-5">
    <div class="row title-container align-items-center" style="padding: 10px;">
        <img src="./assets/icons/arrow.svg">
        <span class="label-title ml-2 mr-3"> Cadastro de Favorecidos via arquivo</span>
    </div>
    <div class="nav nav-tabs mt-4" id="nav-tab" role="tablist">
        <ng-container *ngIf="collaboratorType">
            <ng-container *ngFor="let item of collaboratorType">
                <a class="nav-item nav-link" [ngClass]="{'active': item.collaboratorTypeId == 1}" id="nav-{{item.collaboratorType}}-tab" data-toggle="tab" href="#nav-{{item.collaboratorType}}" role="tab" attr.aria-controls="nav-{{item.collaboratorType}}" aria-selected="false" (click)="tipocolaborador(item.collaboratorTypeId)">
                    {{item.collaboratorType}}
                </a>
            </ng-container>
        </ng-container>
    </div>
    <div class="component-box container-fluid m-0 p-0 rounded-bottom">
        <div class="p-5">
            <div class="row container-fluid text-center type-tabs">
                <div *ngFor="let item of opcoesArquivo" class="col-6 clickable purchaseTab"
                    (click)="setOpcaoArquivo(item)"
                    [ngClass]="opcaoArquivoSelecionado === item ? 'btm custom-button-pedido selecionado' : 'btm custom-button-pedido' ">
                    {{item.nome}}
                </div>
            </div>
            <div class="container-fluid mt-3">
                <!--special Bankei Tabela-->
                <div [hidden]="opcaoArquivoSelecionado?.Id !== 4" class="">
                    <div class="col-12 px-0 mb-4">
                        <div class="row container-fluid mx-0 px-0 justify-content-center">
                            <div id="tabela" class="mt-3" style="overflow: auto;"></div>
                        </div>
                    </div>
                    <p class="clean-text m-0 mt-4" style="font-size: small;">
                        * Campos obrigatórios para o cadastro<br>
                    </p>      
                    <div class="col-12 text-right button-container mt-5 mb-3">
                        <button type="button" class="custom-button-full" (click)="continuarTabela()">
                            CONTINUAR
                        </button>
                    </div>
                </div>
                <!--resto-->
                <div [hidden]="opcaoArquivoSelecionado?.Id === 4" class="row mt-5">
                    <div class="col-4">
                        <app-upload-arquivo [accept]="accept" (file)="setFile($event)"></app-upload-arquivo>
                    </div>
                    <div *ngIf="opcaoArquivoSelecionado?.urlArquivoExemplo" class="col-8 center justify-content-start">
                        <span class="black">
                            <a class="simple" download="Template-{{ collaboratorType[tipoColaborador-1].collaboratorType }}.csv" [href]="download">
                                Clique aqui
                            </a>para baixar nosso template do arquivo do {{ collaboratorType[tipoColaborador-1].collaboratorType }}. 
                            </span>
                            <i class="fas fa-info-circle info-icon-background popover-content pl-1" style="cursor: pointer;" [ngbPopover]="popContent" triggers="mouseenter:mouseleave" aria-hidden="true"></i>
                    </div>
                    <p class="clean-text col m-0 mt-4" style="font-size: small;">
                        * Campos obrigatórios para o cadastro<br>
                    </p>      
                    <div class="col-12 text-right button-container mt-5 mb-3">
                        <button type="button" class="custom-button-full" (click)="continuarArquivo()">
                            CONTINUAR
                        </button>
                    </div>
                </div>        
            </div>
        </div>
    </div>
</div>

<ng-template #popContent>
    Dica: Após baixar o template, abra-o no excel utilizando a opção importar, se necessário, informe o separador ';' para apresentar as colunas.
    <br><br>
    O template somente será processado se todos os registros estiverem aptos para serem importados.
</ng-template>